module.exports = __webpack_public_path__ + "img/拓幻官网滤镜icon_滤镜粉夏.839c4859.png";